import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-3 row" }
const _hoisted_2 = { class: "col-sm-9" }
const _hoisted_3 = { class: "mb-3 row" }
const _hoisted_4 = { class: "col-sm-9" }
const _hoisted_5 = { class: "mb-3 row" }
const _hoisted_6 = { class: "col-sm-9" }
const _hoisted_7 = { class: "mb-3 row" }
const _hoisted_8 = { class: "col-sm-9" }
const _hoisted_9 = { class: "document-templates-grid" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 3 }

import {ref, reactive, computed} from "vue";
import BGrid from "./BGrid/BGrid.vue";
import type {BTableColumn} from "./BTable/BTable.types";
import {FormModal, SystemAlerts, ConfirmModal} from "./Misc";
import type {DocumentTemplate, DocumentTemplateUpdateRequest} from "../audit.types";
import {useFormValidation} from "../validation";
import {BInput, BTextarea, BFileInput} from "./Fields";
import {useAuditDocumentTemplateStore} from "@/stores/auditDocumentTemplateStore";
import {object, string, date, mixed} from "yup";
import {storeToRefs} from "pinia";
import {useConfirmDialog} from "@/composable/useConfirmDialog";

export default /*@__PURE__*/_defineComponent({
  __name: 'AuditDocumentTemplates',
  props: {
    title: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const {confirm} = useConfirmDialog();

const props = __props;

const documentTemplate = ref<DocumentTemplate>({} as DocumentTemplate);
const isShowCreateEditor = ref(false);
const auditDocumentTemplateStore = useAuditDocumentTemplateStore();

const {loading} = storeToRefs(auditDocumentTemplateStore);

const schema = object<DocumentTemplate>({
    name: string().required().max(50).label("Name"),
    description: string().nullable().max(500).label("Description"),
    file: mixed().required().label("File"),
});

const columns = reactive<BTableColumn[]>([
    {
        key: "name",
        text: "Name",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["name"],
    },
    {
        key: "description",
        text: "Description",
        sortable: true,
        columnClass: ["align-top"],
        value: (item) => item["description"],
    },
    {
        key: "updated-by",
        text: "Updated By",
        sortable: true,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.updatedBy,
    },
    {
        key: "updated-on",
        text: "Updated Date",
        sortable: true,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.updatedOn,
    },
    {
        key: "actions",
        text: "",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap text-end"],
        value: (item) => item["link"],
    },
]);

const showCreateEditor = () => {
    resetValidation();
    documentTemplate.value = {} as DocumentTemplate;
    isShowCreateEditor.value = true;
};

const getData = async () => {
    await auditDocumentTemplateStore.list();
};

const canAdd = computed(() => props.createAudits);

const canDelete = (): boolean => props.runAudits;

const isShowDeleteDialog = ref(false);

const hideDeleteConfirmEditor = async function () {
    isShowDeleteDialog.value = false;
};

const deleteDocument = async (id: number) => {
    const shouldProceed = await confirm("Delete Confirmation", "Are You Sure?");
    if (shouldProceed) {
        await auditDocumentTemplateStore.deleteItem(id);
        hideDeleteConfirmEditor();
        getData();
    }
};

const isShowReplaceDocument = ref(false);

const replaceDocumentSchema = object<DocumentTemplate>({
    file: mixed().required().label("File"),
});
const replaceDocument = ref<DocumentTemplateUpdateRequest>({} as DocumentTemplateUpdateRequest);

const showReplaceDocument = async (id: number) => {
    resetValidation();
    replaceDocument.value = {} as DocumentTemplateUpdateRequest;
    isShowReplaceDocument.value = true;
    replaceDocument.value.id = id;
};

const replaceDocumentTemplate = async () => {
    if (await handleSubmit(replaceDocumentSchema, replaceDocument.value)) {
        await auditDocumentTemplateStore.replace(replaceDocument.value);
        await getData();
        isShowReplaceDocument.value = false;
    }
};

const {handleSubmit, errors, resetValidation} = useFormValidation();

const createDocumentTemplate = async () => {
    if (await handleSubmit(schema, documentTemplate.value)) {
        await auditDocumentTemplateStore.create(documentTemplate.value);
        await getData();
        isShowCreateEditor.value = false;
        documentTemplate.value = {} as DocumentTemplate;
    }
};
;(
  ([__temp,__restore] = _withAsyncContext(() => getData())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(FormModal), {
      title: "Create Document Template",
      onSubmit: createDocumentTemplate,
      loading: _unref(loading),
      modelValue: isShowCreateEditor.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isShowCreateEditor).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_1, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              for: "documentTemplateName",
              class: "col-sm-3 col-form-label"
            }, " Name:", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(BInput), {
                id: "documentTemplateName",
                name: "documentTemplateName",
                type: "text",
                modelValue: documentTemplate.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((documentTemplate.value.name) = $event)),
                error: _unref(errors).name
              }, null, 8, ["modelValue", "error"])
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "documentTemplateDescription",
              class: "col-sm-3 col-form-label"
            }, "Description:", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(BTextarea), {
                class: "form-control",
                name: "documentTemplateDescription",
                modelValue: documentTemplate.value.description,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((documentTemplate.value.description) = $event)),
                error: _unref(errors).description
              }, null, 8, ["modelValue", "error"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "documentTemplateFile",
              class: "col-sm-3 col-form-label"
            }, "File:", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(BFileInput), {
                modelValue: documentTemplate.value.file,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((documentTemplate.value.file) = $event)),
                name: "documentTemplateFile",
                error: _unref(errors).file
              }, null, 8, ["modelValue", "error"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["loading", "modelValue"]),
    _createVNode(_unref(FormModal), {
      title: "Replace Document",
      loading: _unref(loading),
      onSubmit: replaceDocumentTemplate,
      modelValue: isShowReplaceDocument.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isShowReplaceDocument).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              for: "replaceDocumentTemplateFile",
              class: "col-sm-3 col-form-label"
            }, " File: ", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(BFileInput), {
                modelValue: replaceDocument.value.file,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((replaceDocument.value.file) = $event)),
                name: "replaceDocumentTemplateFile",
                error: _unref(errors).file
              }, null, 8, ["modelValue", "error"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["loading", "modelValue"]),
    _createVNode(_unref(SystemAlerts)),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(BGrid, {
        caption: "List of document templates",
        tableOptions: _unref(auditDocumentTemplateStore).tableOptions,
        filterableFields: _unref(auditDocumentTemplateStore).filterableFields,
        filterOptions: _unref(auditDocumentTemplateStore).filterOptions,
        onOptionChange: getData,
        items: _unref(auditDocumentTemplateStore).items,
        columns: columns,
        loading: _unref(auditDocumentTemplateStore).loading
      }, {
        beforeFilter: _withCtx(() => [
          (canAdd.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _withModifiers(showCreateEditor, ["prevent"]),
                class: "btn btn-primary"
              }, " Create Document Template "))
            : _createCommentVNode("", true)
        ]),
        "cell.actions": _withCtx(({item}) => [
          (item.fileId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "btn btn-sm btn-secondary me-2",
                href: `api/v1/audit/file/${item.fileId}`
              }, "View Document", 8, _hoisted_10))
            : _createCommentVNode("", true),
          canDelete
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _withModifiers(($event: any) => (showReplaceDocument(item.id)), ["prevent"]),
                "aria-label": "Replace Document",
                type: "button",
                class: "btn btn-sm btn-primary me-2"
              }, " Edit ", 8, _hoisted_11))
            : _createCommentVNode("", true),
          canDelete
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: _withModifiers(($event: any) => (deleteDocument(item.id)), ["prevent"]),
                type: "button",
                class: "btn btn-sm btn-danger"
              }, " Delete ", 8, _hoisted_12))
            : (_openBlock(), _createElementBlock("span", _hoisted_13))
        ]),
        _: 1
      }, 8, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading"])
    ]),
    _createVNode(_unref(ConfirmModal))
  ], 64))
}
}

})